export default __webpack_public_path__ + "static/media/home-web-agency-bg-img-01.1aaaf3a8.jpg";